// extracted by mini-css-extract-plugin
export default {"quickActions":"QuickActions_quickActions__SWVLp","actionButton":"QuickActions_actionButton__6fz+e","actionIcon":"QuickActions_actionIcon__FIDhP"};